import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const buildAuthPayload = (extra = {}) => {
  const auth = store.getState().auth;
  return {
    auth_key: auth.user.auth_key,
    salon_id: auth.user.salon_id,
    ...extra,
  };
};

const updateXeroKey = (values = {}) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();

  const clientId = values.xero_client_id || values.client_id || "";
  const clientSecret = values.xero_secret_id || values.client_secret || "";

  formData.append("client_id", clientId);
  formData.append("client_secret", clientSecret);
  formData.append("salon_id", auth.user.salon_id);

  const action = "afterlogin/xero/connect";
  formData.append("auth_key", auth_key);
  formData.append("action", action);

  return axios.post(API_URL + action, formData, {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const handleCallback = (code) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();

  formData.append("code", code);
  formData.append("auth_key", auth_key);

  const action = "afterlogin/xero/callback";
  return axios.post(API_URL + action, formData, {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const disconnect = () => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();

  const action = "afterlogin/xero/disconnect";
  formData.append("auth_key", auth_key);
  formData.append("action", action);

  return axios.post(API_URL + action, formData, {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const fetchConnection = () => {
  const action = "afterlogin/xero/logs/connection";
  return axios.post(API_URL + action, buildAuthPayload({ action }), {
    headers: authHeader(),
  });
};

const buildFilterPayload = (values = {}) => ({
  status: values.status || "",
  invoice_numbers: values.invoice_numbers || [],
  paidby: values.paidby || [],
});

const fetchFilterOptions = () => {
  const action = "afterlogin/xero/logs/filter-options";
  return axios.post(API_URL + action, buildAuthPayload({ action }), {
    headers: authHeader(),
  });
};

const fetchAnalytics = (values = {}) => {
  const period = values.period ?? values.days ?? "all";
  const days = period === "all" ? 0 : Math.min(90, Math.max(7, parseInt(period, 10) || 30));
  const action = "afterlogin/xero/logs/analytics";
  return axios.post(
    API_URL + action,
    buildAuthPayload({
      action,
      days,
      period,
      ...buildFilterPayload(values),
    }),
    { headers: authHeader() }
  );
};

const fetchLogs = (values = {}) => {
  const page = Math.max(1, parseInt(values.page, 10) || 1);
  const limit = Math.min(500, Math.max(1, parseInt(values.limit, 10) || 20));
  const action = "afterlogin/xero/logs/list";
  const payload = buildAuthPayload({
    action,
    page,
    limit,
    ...buildFilterPayload(values),
  });

  return axios.post(`${API_URL}${action}?page=${page}`, payload, {
    headers: authHeader(),
  });
};

const resyncLog = (logId) => {
  const action = "afterlogin/xero/logs/resync";
  return axios.post(
    API_URL + action,
    buildAuthPayload({ action, log_id: logId }),
    { headers: authHeader() }
  );
};

const XeroService = {
  updateXeroKey,
  handleCallback,
  disconnect,
  fetchConnection,
  fetchFilterOptions,
  fetchAnalytics,
  fetchLogs,
  resyncLog,
};

export default XeroService;
